import TheGrid from '@/views/stars/sellin_objectives/grid'
import Edit from '@/views/stars/sellin_objectives/edit'
import Importer from '@/views/stars/sellin_objectives/import'

export default {
  path: '/stars/sellin_objectives',
  redirect: '/stars/sellin_objectives/index',
  name: 'sellin_objectives',
  meta: {
    auth: {
      redirect: {
        name: 'sellin_objectives.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Sellin Objectivos'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'sellin_objectives.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'sellin_objectives.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'import',
    name: 'sellin_objectives.import',
    component: Importer,
    meta: {
      auth: true,
      label: 'Importar'
    }
  }, {
    path: 'edit/:id',
    name: 'sellin_objectives.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
